const GET_DEFAULT_CONTAINER_PROPS = () => ({
  containerSelector: "",
  redirects: {
    onBackClick: {
      to: "/"
    },
    link: {
      to: "/"
    }
  }
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
